import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { PageHero, Overline, SectionTitle } from "../components/blocks";
import { Reveal } from "../components/motion/Reveal";
import { IMAGES } from "../content/defaultContent";

export default function About() {
  const { content } = useLanguage();
  const a = content.about;
  return (
    <div data-testid="about-page">
      <PageHero overline={a.hero.overline} title={a.hero.title} subtitle={a.hero.subtitle} image={IMAGES.b2b} />

      <section className="bg-brand-beige py-24 md:py-32">
        <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-16 px-6 md:grid-cols-2 md:px-12">
          <Reveal variant="up">
            <SectionTitle className="mb-6">{a.story.title}</SectionTitle>
            <p className="text-lg leading-relaxed text-brand-black/75">{a.story.body}</p>
          </Reveal>
          <Reveal variant="up" delay={0.15}>
            <SectionTitle className="mb-6">{a.mission.title}</SectionTitle>
            <p className="text-lg leading-relaxed text-brand-black/75">{a.mission.body}</p>
          </Reveal>
        </div>
      </section>

      <section className="bg-white py-24 md:py-32">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12">
          <div className="grid grid-cols-1 gap-px overflow-hidden border border-brand-grey bg-brand-grey md:grid-cols-3">
            {a.pillars.map((p, i) => (
              <Reveal key={i} variant="up" delay={i * 0.1} className="bg-white p-10">
                <span className="font-mono text-sm text-brand-gold">0{i + 1}</span>
                <h3 className="mt-6 font-serif text-3xl text-brand-green">{p.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-brand-black/70">{p.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
